import React from 'react';
import DTOTopPerformer from './DTOTopPerformer';
import TopPerformerPresenter from './TopPerformerPresenter';

import { useTranslation } from 'react-i18next';
function TopPerformerController() {
  const { t } = useTranslation();

  return (
    <div>
      <DTOTopPerformer />
      <TopPerformerPresenter trans={t} />
    </div>
  );
}

export default TopPerformerController;
